module.exports = {
      id: "video-play-btn-usage",
      viewBox: "0 0 82 82",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#video-play-btn",
      toString: function () {
        return this.url;
      }
    }